import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";

import Loading from "../../../components/Loading";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { parseISO, format, parse } from 'date-fns';

import Data from '../../../../repository';

import styles from '../../../../styles/Admin.module.scss';

function Create() {
	const navigate = useNavigate();
	const { id } = useParams();

	const [loading, setLoading] = useState(true);
	const [studio, setStudio] = useState(null);
	const [withheld, setWithheld] = useState({
		name: "",
		start: "",
		end: "",
		sessions: [{
			day: 'Mon',
			start: '00:00',
			end: '01:00'
		}]
	})
	const [buttonLoading, setButtonLoading] = useState(false);

	useEffect(async () => {
		await fetchStudio();
	}, [])

	const fetchStudio = async () => {
		setLoading(true);
		const studio = await Data.fetchStudio(id);
		setStudio(studio.data);
		setLoading(false);
	}

	const addPeriod = (e) => {
		e.preventDefault();

		setWithheld({
			...withheld,
			sessions: [
				...withheld.sessions,
				{
					day: 'Mon',
					start: '00:00',
					end: '01:00'
				}
			]
		})
	}

	const updatePeriodDay = (idx, e) => {
		let sessions = withheld.sessions;
		sessions[idx] = {
			...sessions[idx],
			day: e.target.value
		}

		setWithheld({
			...withheld,
			sessions
		})
	}

	const updatePeriodTime = (idx, field, date) => {
		let sessions = [...withheld.sessions];
		sessions[idx] = {
			...sessions[idx],
			[field]: date ? format(date, 'HH:mm') : ''
		}

		setWithheld({
			...withheld,
			sessions
		})
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		setButtonLoading(true);

		let withhelds = studio.withheld;
		withhelds.push(withheld);

		const newStudio = {
			...studio,
			withheld: withhelds
		}

		await Data.updateStudio(newStudio);
		navigate(`/admin/studios/${newStudio._id}`)
	}

	if(loading) return <Loading button={false} />

	return (
		<form className={styles.form} onSubmit={handleSubmit}>
			<div>
				<p>Name:</p>
				<input type="text" value={withheld.name} required={true} minLength={1} onChange={(e) => { return setWithheld({ ...withheld, name: e.target.value }) }} />
			</div>
			<div>
				<p>Effective From:</p>
				<DatePicker
					value={withheld.start ? parseISO(withheld.start) : null}
					onChange={(date) => setWithheld({ ...withheld, start: date ? format(date, 'yyyy-MM-dd') : '' })}
				/>
			</div>
			<div>
				<p>Effective To:</p>
				<DatePicker
					value={withheld.end ? parseISO(withheld.end) : null}
					onChange={(date) => setWithheld({ ...withheld, end: date ? format(date, 'yyyy-MM-dd') : '' })}
				/>
			</div>

			<h2>Periods</h2>
			{withheld.sessions.map((period, idx) => {
				return (
					<div className={styles.period}>
						<select value={period.day} onChange={updatePeriodDay.bind(this, idx)}>
							<option value="Mon">Mon</option>
							<option value="Tue">Tue</option>
							<option value="Wed">Wed</option>
							<option value="Thu">Thu</option>
							<option value="Fri">Fri</option>
							<option value="Sat">Sat</option>
							<option value="Sun">Sun</option>
						</select>
						<TimePicker
							value={period.start ? parse(period.start, 'HH:mm', new Date()) : null}
							onChange={(date) => updatePeriodTime(idx, 'start', date)}
							ampm={false}
						/>
						<TimePicker
							value={period.end ? parse(period.end, 'HH:mm', new Date()) : null}
							onChange={(date) => updatePeriodTime(idx, 'end', date)}
							ampm={false}
						/>
					</div>
				)
			})}
			<button className="btn btnEmpty" onClick={addPeriod}>+ Add Period</button>
			<button className="btn btnPrimary" disabled={buttonLoading}>
				{buttonLoading ?
					<Loading button={true} />
				:
					`Save`
				}
			</button>
		</form>
	)
}

export default Create;
